import { __decorate } from "tslib";
import { Action, Getter, Mutation, State } from "@/types";
import { service } from "@/services";
export class OrganizationModule {
    constructor() {
        this.organizations = [];
        this.organizationsForUser = [];
        this.countForUser = 0;
        this.count = 0;
        this.axiosError = null;
    }
    setItems(organization) {
        this.organizations = organization;
    }
    setTotal(count) {
        this.count = count;
    }
    setItemsForUser(organization) {
        this.organizationsForUser = organization;
    }
    setTotalForUser(count) {
        this.countForUser = count;
    }
    setError(error) {
        this.axiosError = error;
    }
    get list() {
        return this.organizations;
    }
    get total() {
        return this.count;
    }
    get listForUser() {
        return this.organizationsForUser;
    }
    get totalForUser() {
        return this.countForUser;
    }
    get errorList() {
        return this.axiosError;
    }
    async get(options) {
        try {
            const data = await service.organization.get(options);
            this.setItems(data.items);
            this.setTotal(data.total);
        }
        catch (error) {
            this.setError(error);
            // push into Notice
            // server text error - "error.response.data.message"
            // or default error - "error.response.statusText"
            // or custom error message
            // or return Promise.reject(error)
        }
    }
    async getBaseForUser(options) {
        try {
            const data = await service.organization.getBaseForUser(options);
            this.setItemsForUser(data.items);
            this.setTotalForUser(data.total);
        }
        catch (error) {
            this.setError(error);
            // push into Notice
            // server text error - "error.response.data.message"
            // or default error - "error.response.statusText"
            // or custom error message
            // or return Promise.reject(error)
        }
    }
    async add(organization) {
        try {
            await service.organization.add(organization);
            return true;
        }
        catch (error) {
            this.setError(error);
            return false;
        }
    }
    async edit(organization) {
        try {
            await service.organization.edit(organization);
            return true;
        }
        catch (error) {
            this.setError(error);
            return false;
            // push into Notice
            // server text error - "error.response.data.message"
            // or default error - "error.response.statusText"
            // or custom error message
            // or return Promise.reject(error)
        }
    }
    async delete(payloads) {
        try {
            const { id, confirm = false, } = payloads;
            await service.organization.delete(id, confirm);
            return true;
        }
        catch (error) {
            this.setError(error);
            return false;
            // push into Notice
            // server text error - "error.response.data.message"
            // or default error - "error.response.statusText"
            // or custom error message
            // or return Promise.reject(error)
        }
    }
}
__decorate([
    State()
], OrganizationModule.prototype, "organizations", void 0);
__decorate([
    State()
], OrganizationModule.prototype, "organizationsForUser", void 0);
__decorate([
    State()
], OrganizationModule.prototype, "countForUser", void 0);
__decorate([
    State()
], OrganizationModule.prototype, "count", void 0);
__decorate([
    State()
], OrganizationModule.prototype, "axiosError", void 0);
__decorate([
    Mutation()
], OrganizationModule.prototype, "setItems", null);
__decorate([
    Mutation()
], OrganizationModule.prototype, "setTotal", null);
__decorate([
    Mutation()
], OrganizationModule.prototype, "setItemsForUser", null);
__decorate([
    Mutation()
], OrganizationModule.prototype, "setTotalForUser", null);
__decorate([
    Mutation()
], OrganizationModule.prototype, "setError", null);
__decorate([
    Getter()
], OrganizationModule.prototype, "list", null);
__decorate([
    Getter()
], OrganizationModule.prototype, "total", null);
__decorate([
    Getter()
], OrganizationModule.prototype, "listForUser", null);
__decorate([
    Getter()
], OrganizationModule.prototype, "totalForUser", null);
__decorate([
    Getter()
], OrganizationModule.prototype, "errorList", null);
__decorate([
    Action()
], OrganizationModule.prototype, "get", null);
__decorate([
    Action()
], OrganizationModule.prototype, "getBaseForUser", null);
__decorate([
    Action()
], OrganizationModule.prototype, "add", null);
__decorate([
    Action()
], OrganizationModule.prototype, "edit", null);
__decorate([
    Action()
], OrganizationModule.prototype, "delete", null);
